module.exports = __webpack_public_path__ + "img/416 (1).b9779ee.png";